/**
 * Video Comprehension Layer — canonical analytics contracts.
 *
 * The single source of truth for:
 *   - the per-view event envelope (§5 of the design doc),
 *   - the event taxonomy (§6),
 *   - the slide → parent `postMessage` interaction contract (§8.2).
 *
 * Shared by the web-ui SDK (producer), the /api/analytics/collect route, and
 * the worker consumer. The envelope and the postMessage contract are the two
 * things most expensive to change later — treat them as frozen.
 *
 * Design: docs/engineering/video-comprehension-layer-design-2026-06-20.md
 */
/** Narrowing guard for the parent-side listener. */
export function isSlideAnalyticsMessage(data) {
    return (typeof data === 'object' &&
        data !== null &&
        data.__ivy_analytics === true &&
        typeof data.type === 'string');
}
